var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPharmuniBusinessMobile = function SvgPharmuniBusinessMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18BBA8",
    stroke: "#18BBA8",
    d: "M18.056 7.35v3.737l-1.204 1.21V4.151a4.796 4.796 0 0 1 1.204 3.199Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#18BBA8",
    stroke: "#18BBA8",
    d: "M12.727 16.441V2.527a4.698 4.698 0 0 1 1.025.001V15.41l-1.025 1.031Z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#18BBA8",
    stroke: "#18BBA8",
    d: "M8.39 7.353c0-1.243.47-2.377 1.24-3.24v15.429l-1.24 1.246V7.353Z"
  })));
};
export default SvgPharmuniBusinessMobile;